import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Teleport as _Teleport, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7519f487"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header fixed-top" }
const _hoisted_2 = {
  id: "header",
  class: "fixed-top"
}
const _hoisted_3 = { class: "d-flex align-items-center items" }
const _hoisted_4 = {
  id: "navbar",
  class: "navbar navbar-expand-xs"
}
const _hoisted_5 = { class: "dropdown" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { href: "#" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Help"),
  /*#__PURE__*/_createElementVNode("i", {
    class: "fa-solid fa-angle-down",
    style: {"color":"#ffffff"}
  })
], -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-list mobile-nav-toggle" }, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { id: "logo-group" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "icon" }),
  /*#__PURE__*/_createElementVNode("a", {
    href: "#",
    class: "db-name"
  }, "QuanDB")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_SearchBar = _resolveComponent("SearchBar")!
  const _component_DrawerView = _resolveComponent("DrawerView")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("header", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("nav", _hoisted_4, [
          _createElementVNode("ul", null, [
            _createElementVNode("li", null, [
              _createVNode(_component_router_link, {
                class: "nav-link scrollto",
                to: "/"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Home")
                ]),
                _: 1
              })
            ]),
            _createElementVNode("li", null, [
              _createVNode(_component_router_link, {
                class: "nav-link scrollto",
                to: "/browse"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Browse")
                ]),
                _: 1
              })
            ]),
            _createElementVNode("li", null, [
              _createVNode(_component_router_link, {
                class: "nav-link scrollto",
                to: "/download"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Download")
                ]),
                _: 1
              })
            ]),
            _createElementVNode("li", _hoisted_5, [
              _hoisted_6,
              _createElementVNode("ul", null, [
                _createElementVNode("li", null, [
                  _createVNode(_component_router_link, { to: "/explanation" }, {
                    default: _withCtx(() => [
                      _createTextVNode("Explanation")
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("li", null, [
                  _createVNode(_component_router_link, { to: "/statistics" }, {
                    default: _withCtx(() => [
                      _createTextVNode("Statistics")
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("li", null, [
                  _createVNode(_component_router_link, { to: "/documentation" }, {
                    default: _withCtx(() => [
                      _createTextVNode("Documentation")
                    ]),
                    _: 1
                  })
                ])
              ])
            ]),
            _createElementVNode("li", null, [
              _createVNode(_component_router_link, {
                class: "nav-link scrollto",
                href: "#team",
                to: "/contact"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Contact")
                ]),
                _: 1
              })
            ])
          ]),
          _hoisted_7
        ])
      ])
    ]),
    _createElementVNode("div", {
      class: _normalizeClass({'d-flex': true, 'align-items-center': true, 'title': true, 'top': !$setup.touchTop})
    }, [
      _createElementVNode("div", {
        class: _normalizeClass({'my-container': true, 'level-top': !$setup.touchTop})
      }, [
        _hoisted_8,
        _createVNode(_component_SearchBar, { "touch-top": $setup.touchTop }, null, 8, ["touch-top"])
      ], 2)
    ], 2),
    (_openBlock(), _createBlock(_Teleport, { to: "html" }, [
      ($setup.showEditor)
        ? (_openBlock(), _createBlock(_component_DrawerView, { key: 0 }))
        : _createCommentVNode("", true)
    ]))
  ]))
}